module.exports = __webpack_public_path__ + "static/media/download-icon.f69b02a1.svg";